<template>
  <ai-tool-tip
    role="alert"
    variant="inProcess"
    align-item="center"
    :label="$t('booking.tooltip.childAsAdult', { count })" />
</template>

<script setup lang="ts">
import { useBookingStore } from '../../store';

const bookingStore = useBookingStore();

const count = computed(() => bookingStore.childAsAdult);
</script>
